module.exports = __webpack_public_path__ + "static/media/Scarlet_Pen_Award.8c487cf1.jpg";